export const E_WASTE_REQUEST_ID_PREFIX = 'EREQ';

export const E_WASTE_TYPES = [
  'IT & Telecommunication Equipments',
  'Consumer Electronics & Solar Cell',
  'Large & Small Electronic Equipments',
  'Electrical and Electronic Tools',
  'Toys, Leisure and Sports Equipment',
  'Medical Devices'
];

export const METHODS_OF_DISPOSAL = [
  'Landfill',
  'Incineration (Burn)',
  'Recycling',
  'Storage'
];

export const BUSINESS_TYPES = [
  'Authorised service center',
  'Retailer',
  'Modern Trade',
  'Distributor',
  'Brand Shop',
  'Freelancer',
  'SSD ( Sales & service dealer)',
  'Manufacturer',
  'Producer',
  'Refurbisher',
  'Bulk Consumer',
  'Dismantler',
  'Recycler',
  'NGO'
];
